import React from 'react';
import styles from '../../../styles/Account.module.css';

const SkeletonLine: React.FC<{ width?: string; height?: number }> = ({ width = '100%', height = 16 }) => (
  <div className={styles.skeletonLine} style={{ width, height }} />
);

const SkeletonSection: React.FC<{ rows?: number; hasButton?: boolean }> = ({ rows = 5, hasButton = false }) => (
  <div className={styles.skeletonCard}>
    {/* Section title row */}
    <div className={styles.skeletonHeaderRow}>
      <SkeletonLine width="28%" height={22} />
      {hasButton && <div className={styles.skeletonButton} />}
    </div>
    {/* Grid of label + value rows */}
    <div className={styles.skeletonGrid}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={styles.skeletonRow}>
          <SkeletonLine width="35%" height={13} />
          <SkeletonLine width="60%" height={16} />
        </div>
      ))}
    </div>
  </div>
);

const AccountSkeleton: React.FC = () => (
  <div className={styles.accountContent}>
    <div className={styles.accountInner}>
      <SkeletonSection rows={5} hasButton={true} />
      <SkeletonSection rows={4} hasButton={false} />
    </div>
  </div>
);

export default AccountSkeleton;
